// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1RF8A","policyContent":"styles_policyContent__1KZom"};